import FooterPricing from "src/components/pricingbusiness/footer";
import Hero from "src/components/pricingbusiness/hero";
import Features from "src/components/pricingbusiness/features";
import ServiceBusiness from "src/components/pricingbusiness/servicebusiness";
import BizAnimationTitle from "src/components/business/bizAnimationTitle";

const PricingBusiness = () => {
  return (
    <>
      <div className="mt-10" />
      <Hero />
      <div className="mt-20" />
      <Features />
      <div className="mt-20" />
      <BizAnimationTitle />
      <ServiceBusiness />

      <div className="mt-20" />
      <FooterPricing />
    </>
  );
};

export default PricingBusiness;
